export const booleanOptions = [
  { labelKey: 'Si', value: 'true' },
  { labelKey: 'No', value: 'false' },
]
